import React from 'react';
import LockIcon from 'resources/lock_icon.png';
import PurpleW from 'resources/PurpleW.png';
import './WStoreDiscoverItem.css';

const WStoreDiscoverItem = ({ onSelect, item, locked }) => {
  const itemImageClassSuffix = locked ? 'locked' : '';

  const handleSelectOrViewItem = item => onSelect(item, true);

  const renderRedeemButton = () => (
    <button
      className="discover-redeem-button"
      type="button"
      onClick={() => handleSelectOrViewItem(item)}
    >
      {locked ? (
        'View'
      ) : (
        <>
          <span className="discover-redeem-plus">+</span>
          Redeem
        </>
      )}
    </button>
  );

  return (
    <div className="wstore-discover-item">
      <div className="image-wrapper">
        <img
          className={`discover-item-image ${itemImageClassSuffix}`}
          src={item.imageUrl || PurpleW}
          alt={`Icon for ${item.name}`}
        />
      </div>
      {locked && (
        <img
          className="discover-lock-icon"
          src={LockIcon}
          alt="Lock icon overlapping the item icon"
        />
      )}
      <div className="discover-item-name">{item.name}</div>
      {renderRedeemButton()}
    </div>
  );
};

export default WStoreDiscoverItem;
